import React from "react";
import { useParams } from "react-router-dom";
import WayfinderLayout from "./WayfinderLayout";
import GlobalAvatarSettings from "./GlobalAvatarSettings";

const AvatarPage = ({ buttonColor }) => {
  const { userId } = useParams();
  return <GlobalAvatarSettings userId={userId} buttonColor={buttonColor} />;
};

// Wrap with layout
const AvatarPageWithLayout = () => (
  <WayfinderLayout>
    <AvatarPage />
  </WayfinderLayout>
);

export default AvatarPageWithLayout;
